import AsoHeader from "../../../components/Aso/Header";
import AsoValidarCnpj from "../../../components/Aso/Register/AsoValidarCnpj";

const AsoRegistroValidarCnpj = () => {
    return(
        <>
            <AsoHeader />
            <AsoValidarCnpj />
        </>
    );
}

export default AsoRegistroValidarCnpj;